import useAppSelector from 'hooks/shared/store/useAppSelector';
import { FC, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authSelector } from 'selectors/modules/auth';
import { AuthStatus } from 'slices/modules/auth/authState';
import AppRoute from './AppRoute';
import { getLoginReturnPath } from './getLoginReturnPath';

const AuthRoute: FC<PropsWithChildren> = ({ children }) => {
  const { status } = useAppSelector(authSelector);
  const location = useLocation();

  if (status === AuthStatus.LoggedIn) {
    return (
      <Navigate to={getLoginReturnPath(location.state, AppRoute.home)} replace />
    );
  }

  return <>{children}</>;
};

export default AuthRoute;
